export default __webpack_public_path__ + "a882378d5f5340d20cfd91a7bc0ffcfd.png";